<div class="group-assignment-detail">
  <markant-platform-ui-page-header>
    {{ groupName }}

    @if (groupName) {
      <markant-platform-group-name-edit-dialog
        [groupName]="groupName"
        [groupId]="groupId"
        (groupNameUpdated)="updateGroupNameInUI($event)"
      >
      </markant-platform-group-name-edit-dialog>
    }
  </markant-platform-ui-page-header>

  <div class="sub-header">
    <div class="delete-group-button">
      <markant-platform-group-delete-dialog
        [groupId]="groupId"
      ></markant-platform-group-delete-dialog>
    </div>
  </div>

  @if (!initialLoad) {
    <div class="detail-container">
      <div class="detail-card role-assignment-container">
        <div class="detail-card-header">
          <h5 class="detail-card-header-title">
            {{
              'dashboardOverview.groupAssignment.detail.cartridgeRoleAssignments.title'
                | transloco
            }}
          </h5>
          @if (cartridgeRoleAssignments.length) {
            <markant-icon-button
              icon="m_edit"
              class="button-transparent-secondary-text headline-button"
              colorScheme="primary"
              (keyup)="openRoleAssignmentDialog()"
              (click)="openRoleAssignmentDialog()"
            >
            </markant-icon-button>
          }
        </div>

        @if (cartridgeRoleAssignments.length) {
          <div
            class="role-assignment-cards-container"
            markantPlatformScrollIndicator
          >
            @for (
              cartridgeRoleAssignment of cartridgeRoleAssignments;
              track cartridgeRoleAssignment.id
            ) {
              <markant-platform-ui-cartridge-roles-assignment-card
                class="role-assignment-card"
                [attr.data-cy]="'role-card-' + cartridgeRoleAssignment.id"
                [isRoleLimitEnabled]="isRoleLimitEnabled"
                [cartridgeRoles]="cartridgeRoleAssignment"
                [flow]="CartridgeRoleAssignmentFlow.ReadOnly"
                [hasSuborganizations]="true"
              >
              </markant-platform-ui-cartridge-roles-assignment-card>
            }
          </div>
        } @else {
          <div class="no-data">
            <div class="no-data-container">
              <h5 class="no-data-text">
                {{
                  'dashboardOverview.groupAssignment.detail.cartridgeRoleAssignments.noAssignments'
                    | transloco
                }}
              </h5>
              <!-- todo check usagerights?-->

              <markant-button
                colorScheme="primary"
                variant="clear"
                (keydown.enter)="openRoleAssignmentDialog()"
                (click)="openRoleAssignmentDialog()"
              >
                <markant-icon icon="m_edit" slot="icon-leading"></markant-icon>
                {{
                  'dashboardOverview.groupAssignment.detail.cartridgeRoleAssignments.assign'
                    | transloco
                }}
              </markant-button>
            </div>
          </div>
        }
      </div>

      <div class="detail-card member-table-container">
        <div class="detail-card-header">
          <h5 class="detail-card-header-title">
            {{
              'dashboardOverview.groupAssignment.detail.memberTable.title'
                | transloco
            }}
          </h5>
          @if (totalCount) {
            <markant-icon-button
              class="edit-button"
              icon="m_edit"
              (keydown.enter)="onClickEditMembers()"
              (click)="onClickEditMembers()"
            >
            </markant-icon-button>
          }
        </div>
        @if (totalCount) {
          <markant-platform-table
            class="member-table"
            [data]="mappedTableData"
            [defaultHeaderCells]="tableDraft.headerAndTableCells"
            [loading]="tableIsLoading"
            [totalCount]="totalCount"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            (indexChanged)="onIndexChange($event)"
            (pageSizeChanged)="onPageSizeChange($event)"
            (sortChanged)="onSortChange($event)"
          >
          </markant-platform-table>
        } @else {
          <div class="no-data">
            <div class="no-data-container">
              <h5 class="no-data-text">
                {{
                  'dashboardOverview.groupAssignment.detail.noMember'
                    | transloco
                }}
              </h5>
              <markant-button
                colorScheme="primary"
                variant="clear"
                (keydown.enter)="onClickEditMembers()"
                (click)="onClickEditMembers()"
              >
                <markant-icon
                  icon="m_edit-small"
                  slot="icon-leading"
                ></markant-icon>
                {{
                  'dashboardOverview.groupAssignment.detail.addMember'
                    | transloco
                }}
              </markant-button>
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="flex-centered">
      {{ 'general.loading' | transloco }}
      <markant-spinner></markant-spinner>
    </div>
  }
</div>

@if (isGroupMemberDialogOpen) {
  <markant-platform-group-assignment-member-edit-dialog
    [groupName]="groupName"
    [groupId]="groupId"
    (updateMembersSuccess)="onMemberSuccess()"
    (dialogClosed)="onCloseGroupMemberDialog()"
  ></markant-platform-group-assignment-member-edit-dialog>
}

@if (isUsageRightDialogOpen) {
  <markant-platform-modal-bridge>
    <markant-platform-service-roles-assignments-dialog
      [organizationId]="organizationId ?? ''"
      [groupId]="groupId"
      [groupName]="group.displayName"
      (closeDialog)="isUsageRightDialogOpen = false"
      (reloadRoleAssignments)="reloadGroup()"
    >
    </markant-platform-service-roles-assignments-dialog>
  </markant-platform-modal-bridge>
}
